import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface Project {
  id: string;
  org_id: string;
  name: string;
  slug: string;
  description: string | null;
  is_active: boolean;
  created_at: string;
}

export function useProjects() {
  // D6: no more projectsBus subscription — ProjectsPage invalidates
  // queryKeys.projects.all on mutation, and query-cache identity means
  // every useProjects() consumer (e.g. the sidebar) picks up the
  // invalidation automatically without a hand-rolled event bus.
  const query = useQuery({
    queryKey: queryKeys.projects.list(),
    queryFn: () => api<Project[]>("/api/v2/projects"),
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    projects: query.data ?? [],
    loading: query.isLoading,
    error: query.error ? "Failed to load projects" : "",
    refetch,
  };
}
